// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__29ybt","empty":"ModalGraph_empty__2zoki"};